(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gp-mobile-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gp-mobile-atc')) {
    customElements.define('gp-mobile-atc', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.label = this.button.querySelector('span');
        this.productTitle = this.querySelector('.gp-mobile-atc__title');
        this.priceGroup = this.querySelector('.gp-mobile-atc__price');
        this.price = this.querySelector('.gp-mobile-atc__amount');
        this.error = this.querySelector('.gp-mobile-atc__error');
        this.spacer = this.nextElementSibling;
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.schedule = this.scheduleUpdate.bind(this);
        this.add = this.addToCart.bind(this);
        this.button.addEventListener('click', this.add);
        window.addEventListener('scroll', this.schedule, { passive: true });
        window.addEventListener('resize', this.schedule, { passive: true });
        window.addEventListener('pageshow', this.schedule);
        document.addEventListener('change', this.schedule);
        document.addEventListener('focusin', this.schedule);
        document.addEventListener('focusout', this.schedule);
        window.visualViewport?.addEventListener('resize', this.schedule);
        this.mobile.addEventListener('change', this.schedule);
        this.observer = new MutationObserver((records) => {
          if (!this.mobile.matches) return;
          if (records.some(({ target }) => !this.contains(target) && target !== this.spacer)) {
            this.schedule();
          }
        });
        this.observer.observe(document.body, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['class', 'disabled', 'aria-disabled', 'hidden', 'open', 'style', 'value']
        });
        this.schedule();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.button?.removeEventListener('click', this.add);
        window.removeEventListener('scroll', this.schedule);
        window.removeEventListener('resize', this.schedule);
        window.removeEventListener('pageshow', this.schedule);
        document.removeEventListener('change', this.schedule);
        document.removeEventListener('focusin', this.schedule);
        document.removeEventListener('focusout', this.schedule);
        window.visualViewport?.removeEventListener('resize', this.schedule);
        this.mobile?.removeEventListener('change', this.schedule);
        if (this.spacer) this.spacer.hidden = true;
      }

      scheduleUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      isVisible(element) {
        return Boolean(element && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
      }

      update() {
        this.source = document.querySelector('main [id^="MainProduct-"]');
        this.original = this.source?.querySelector('product-form form[action*="/cart/add"] button[name="add"]');
        this.form = this.original?.form;
        const ready = Boolean(this.mobile.matches && this.form && this.isVisible(this.original));
        this.spacer.hidden = !ready;
        if (!ready) {
          this.hidden = true;
          return;
        }

        const title = this.source.querySelector('h1')?.textContent.trim().toLocaleLowerCase(document.documentElement.lang || 'tr');
        if (title && this.productTitle.textContent !== title) this.productTitle.textContent = title;

        const variant = this.form.querySelector('[name="id"]');
        this.needsSelection = !variant?.value;
        const busy = this.original.classList.contains('loading');
        const blocked = this.original.disabled || this.original.getAttribute('aria-disabled') === 'true' || variant?.disabled;
        this.button.disabled = busy || (!this.needsSelection && Boolean(blocked));
        this.button.setAttribute('aria-busy', String(busy));
        const originalLabel = Array.from(this.original.querySelectorAll('span')).find((span) => this.isVisible(span));
        this.label.textContent = this.needsSelection
          ? this.dataset.chooseOptions
          : (originalLabel?.textContent || this.original.textContent).trim();

        const priceBlock = this.source.querySelector('[id^="price-"]');
        const price = priceBlock?.querySelector('.price');
        const amount = price?.querySelector(price.classList.contains('price--on-sale')
          ? '.price__sale .price-item--sale'
          : '.price__regular .price-item--regular');
        this.price.textContent = this.isVisible(priceBlock) && !this.needsSelection ? amount?.textContent.trim() || '' : '';
        this.priceGroup.hidden = !this.price.textContent;

        const wrapper = this.original.closest('product-form').querySelector('.product-form__error-message-wrapper');
        const message = wrapper && this.isVisible(wrapper)
          ? wrapper.querySelector('.product-form__error-message')?.textContent.trim() || ''
          : '';
        if (this.error.textContent !== message) this.error.textContent = message;
        this.error.hidden = !message;

        const overlay = document.body.classList.contains('overflow-hidden')
          || document.body.classList.contains('overflow-hidden-mobile')
          || document.querySelector('cart-drawer.active, cart-notification.active, .cart-notification.active, product-modal[open], modal-dialog[open], dialog[open]')
          || Array.from(document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs, .cc-window:not(.cc-invisible)')).some((element) => this.isVisible(element));
        const editing = document.activeElement?.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]), textarea, select, [contenteditable="true"]');
        const show = this.original.getBoundingClientRect().bottom <= 0 && !overlay && !editing;
        if (!show && !this.hidden && this.contains(document.activeElement)) this.restoreFocus = true;
        this.hidden = !show;
        if (show) {
          const height = Math.ceil(this.getBoundingClientRect().height);
          this.spacer.style.setProperty('--gp-mobile-atc-height', `${height + 8}px`);
          document.documentElement.style.setProperty('--gp-mobile-atc-height', `${height}px`);
          if (this.restoreFocus && document.activeElement === document.body) this.button.focus({ preventScroll: true });
          this.restoreFocus = false;
        }
      }

      addToCart() {
        this.update();
        if (this.hidden || !this.form || this.button.disabled) return;
        if (this.needsSelection) {
          const picker = this.source.querySelector('variant-selects, variant-radios');
          const target = picker?.querySelector('select, input:not([disabled]), button') || this.original;
          target.focus({ preventScroll: true });
          (picker || target).scrollIntoView({ block: 'center', behavior: 'auto' });
          return;
        }
        const invalid = Array.from(this.form.elements).find((field) => field.willValidate && !field.validity.valid);
        if (invalid) {
          invalid.scrollIntoView({ block: 'center', behavior: 'auto' });
          invalid.focus({ preventScroll: true });
          invalid.reportValidity();
          return;
        }
        this.original.click();
        this.schedule();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
